
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results/[query]",
      function () {
        return require("private-next-pages/results/[query].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/results/[query]"])
      });
    }
  